import {isCodeInServices} from "../../../../utils";

export const getDefaultDeliveryCondition = (shipment) => {
    return {
        COD: !(shipment.Dobierka && shipment.Dobierka.Amount),
        OV: !isCodeInServices(shipment.Services, 'OV'),
        packageCount: shipment.PocetKusov === 1,
    };
};
